// src/components/layouts/app/header/index.tsx
import React, { useState, useEffect } from "react";
import MobileHeader from "./mobile/MobileHeader";
import { DesktopHeader } from "./desktop/DesktopHeader";

const Header: React.FC = () => {
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [isFavoritesOpen, setIsFavoritesOpen] = useState(false);

  useEffect(() => {
    const handleOpenCart = () => setIsCartOpen(true);
    window.addEventListener('openCart', handleOpenCart);
    return () => window.removeEventListener('openCart', handleOpenCart);
  }, []);

  return (
    <>
      {/* Desktop */}
      <div className="hidden md:block">
        <DesktopHeader
          onCartClick={() => setIsCartOpen(true)}
          onFavoritesClick={() => setIsFavoritesOpen(true)}
        />
      </div>

      {/* Mobile : plus de BottomNavBar séparée */}
      <div className="block md:hidden">
        <MobileHeader onFavoritesClick={() => setIsFavoritesOpen(true)} />
      </div>
    </>
  );
};

export default Header;